import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { type SywmAddOptions } from '@/scripts/interactive-defer/swym-init'

export class WishlistButton extends UcoastEl {
	static htmlSelector = 'wishlist-button'
	button: HTMLButtonElement
	onSuccessCallback: (addedListItem: boolean) => void
	onErrorCallback: (error: string) => void

	constructor() {
		super()
		this.button = q.rs('button', this)
		this.onSuccessCallback = this.onSuccess.bind(this)
		this.onErrorCallback = this.onError.bind(this)

		this.button.addEventListener('click', this.onClick.bind(this))
		void this.load()
	}

	onClick() {
		if (!window.UcoastSwym) {
			throw new Error('Swym not loaded')
		}
		window.UcoastSwym.addItemCallback(
			this.getSwymOptions(),
			this.onSuccessCallback,
			this.onErrorCallback
		)
	}

	onSuccess(addedListItem: boolean) {
		if (addedListItem) {
			this.button.classList.add('active')
		} else {
			this.button.classList.remove('active')
		}
		if (window.UcoastSwym) {
			console.log('wishlists', window.UcoastSwym.wishlists)
		}
	}
	onError(error: string) {
		console.error('Swym Add to Wishlist failed')
		console.error(error)
	}

	getSwymOptions(): SywmAddOptions {
		const epi = parseInt(q.ra(this, 'data-epi'))
		const empi = parseInt(q.ra(this, 'data-empi'))
		const du = q.ra(this, 'data-du')
		return {
			epi,
			empi,
			du,
		}
	}

	override connectedCallback() {
		super.connectedCallback()
	}

	async load() {
		if (!window.SwymCallbacks) {
			window.SwymCallbacks = []
		}
	}
}
